<template>
    <v-flex xs12>
        <v-layout column justify-center>
            <v-flex>            
                <v-data-table
                    :headers="dossierItemTableHeaders"
                    :items="dossierItems"
                    hide-actions
                    class="elevation-0 table-striped"
                    style="border-top: 1px #ccc solid"
                >
                    <template slot="items" slot-scope="event">
                        <tr style="cursor: pointer;" @click="infoDossierItemClicked(event.item)">
                            <td class="text-xs-center color-table-bar" :style="`border-left-color: ${color(event.item.messageType)}`"></td>
                            <td class="text-xs-center">
                                <i class="far fa-bell fa-2x grey--text" v-if="event.item.itemType.internalName == 'event'" ></i>
                                <i class="far fa-user-hard-hat fa-2x grey--text" v-if="event.item.itemType.internalName == 'action'" ></i>
                                <i class="far fa-comment-dots fa-2x grey--text" v-if="event.item.itemType.internalName == 'user_message'" ></i>
                                <i class="far fa-image fa-2x grey--text" v-if="event.item.itemType.internalName == 'images'" ></i>
                                <i class="far fa-paperclip fa-2x grey--text" v-if="event.item.itemType.internalName == 'attachments'" ></i>                        
                            </td>
                            <td class="text-xs-left pl-0">{{ event.item.title }}</td>
                            <td class="text-xs-left">{{ event.item.timestamp | time }}</td>
                            <td class="text-xs-left" style="min-w">{{ event.item.timestamp | date_nl }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>
            <v-flex>
                <v-pagination v-if="dossierItemsMeta && dossierItemsMeta.pagination && dossierItemsMeta.pagination.count > 0"             
                    v-model="currentPage"
                    :length="dossierItemsMeta.pagination.total_pages"                           
                    @input="loadDossierItems">
                </v-pagination>                     
            </v-flex>                
        </v-layout>
        <!-- POPUP SCREENS ------------------------------------------------------------>
        <info-asset-event
            :asset="asset"
            :dossierItem="selectedDossierItem"
            v-if="showInfoEvent"
            @closeClicked="showInfoEvent = false"
        ></info-asset-event>
        
        <info-asset-dossier-item
            :asset="asset"
            :dossierItem="selectedDossierItem"
            v-if="showInfoDossierItem"
            @closeClicked="showInfoDossierItem = false"
        ></info-asset-dossier-item>         

        <info-asset-action
            :asset="asset"
            :action="selectedAction"
            :mode="infoAssetActionMode"
            v-if="showInfoAction"
            @closeClicked="showInfoAction = false"
            @actionExecuted="showInfoAction = false"
            @actionCancelled="showInfoAction = false"
        ></info-asset-action>           
    </v-flex>
</template>

<script>
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import InfoAssetEvent from "../../components/asset/InfoAssetEvent";
import InfoAssetAction from "../../components/asset/InfoAssetAction";
import InfoAssetDossierItem from "../../components/asset/InfoAssetDossierItem";
import ColorMixin from "../../plugins/mixins/ColorMixin.js";

    export default {
        components: {
           InfoAssetAction,
           InfoAssetEvent,
           InfoAssetDossierItem,
        },   
        mixins: [ColorMixin],             
        data(){
            return {
                currentPage:1,
                showInfoEvent: false,
                showInfoDossierItem:false,                
                showInfoAction:false,
                infoAssetActionMode: "",  
                selectedAction:null,
                selectedDossierItem:null,
            }
        },        
        props: {
            asset: {
                type: Object
            },
            perPage:{
                default:15
            }

        },        
        computed: {
            ...mapGetters({
                dossierItems:types.ASSET_DOSSIER_ITEMS,
                dossierItemsMeta:types.ASSET_DOSSIER_ITEMS_META 
            }),
            dossierItemTableHeaders() {
                return [
                    {
                        text: "",
                        align: "center",
                        sortable: false,
                        width: "4px"
                    },
                    {
                        text: "",
                        align: "center",
                        sortable: false,
                        width: "10px"
                    },                    
                    {
                        text: "Omschrijving",
                        align: "left",
                        sortable: false
                    },
                    {
                        text: "Tijd",
                        align: "left",
                        sortable: false
                    },
                    {
                        text: "Datum",
                        align: "left",
                        sortable: false,
                        width: "150px"
                    }
                ];
            },
            processedEventTableData() {},            
        },
        methods: {
            infoDossierItemClicked(dossierItem){
                if(dossierItem.itemType.internalName == 'event'){
                    this.infoEventClicked(dossierItem)
                }
                else{
                    this.infoAssetDossierItemClicked(dossierItem)
                }
            },      
            infoAssetDossierItemClicked(dossierItem){
                this.selectedDossierItem = dossierItem;
                this.showInfoDossierItem = true;      
            },
            infoEventClicked(dossierItem) {
                this.selectedDossierItem = dossierItem;
                this.showInfoEvent = true;
            },  
            infoActionClicked(action) {
                this.infoAssetActionMode = "info";
                this.selectedAction = action;
                this.showInfoAction = true;
            },
            cancelActionClicked(action) {
                this.infoAssetActionMode = "cancel";
                this.selectedAction = action;
                this.showInfoAction = true;
            },
            executeActionClicked(action) {
                this.infoAssetActionMode = "execute";
                this.selectedAction = action;
                this.showInfoAction = true;
            },
            discardable(event) {
                if (event.unitTypeEvent.eventType.internalName == "error") {
                    if (event.unitTypeEvent.eventSeverity.id >= 3) {
                    return true;
                    }
                }
                if (event.unitTypeEvent.eventType.internalName == "warning") {
                    if (event.unitTypeEvent.eventSeverity.id >= 5) {
                    return true;
                    }
                }
            }, 
            loadDossierItems() {
                this.$store.dispatch(types.ASSET_DOSSIER_ITEMS, {
                    data: {assetId: this.asset.id},
                    params: {include:"itemType,event.eventType, event.eventSeverity, images",
                             per_page:this.perPage,page:this.currentPage}
                }).then(() => {})                
            },                                    
        },
        mounted(){
            this.loadDossierItems()
        }
    }
</script>

<style lang="scss" scoped>

</style>